export const GoogleAnalyticsEventsEnum = {
  Signin: "signin",
  Signup: "signup",
  CreateTradingAccount: "create_trading_account",
  Deposit: "deposit",
  Withdraw: "withdraw",
  Transfer: "transfer",
  CreateReferralLink: "create_referral_link",
  SubmitIntroducingBrokerApplication: "submit_introducing_broker_application",
  EFXLiteCreateAccountSuccess: "EFX_Lite_account_creation_success",
  EFXProCreateAccountSuccess: "EFX_Pro_account_creation_success",
  MT5CreateAccountSuccess: "MT5_account_creation_success",
};

export const GoogleAnalyticsKYCStepsEnum = {
  Started: "kyc_started",
  TaxIdentification: "kyc_tax_identification",
  EmploymentIdentification: "kyc_employment_identification",
  IncomeIdentification: "kyc_income_identification",
  IDSubmission: "kyc_id_submission",
};
